import React, {useState, useEffect, Fragment} from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from 'sweetalert2';
import { Link } from "react-router-dom";
import NoDataHandler from "../../components/common/NoDataHandler";
import LoadingComponent from "../../components/common/LoadingComponent";

const AllProducts = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);
      
    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get("product-list", setHeader())
        .then((res) => {
            setData(res.data.data);
        })
        .catch((error) => {
            console.error("Error fetching data:", error);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const DeleteData = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) { 
                axiosConfig.get(`delete-product/${id}`, setHeader())
                    .then((res) => {
                        if (!res.data.error) {
                            SweetAlert.fire({
                                title: "Success",
                                text: res.data.messages,
                                icon: "success",
                            });
                            getData(); 
                        } else {
                            SweetAlert.fire({
                                title: "Oops!",
                                text: res.data.messages,
                                icon: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting data:", error);
                        SweetAlert.fire({
                            title: "Error",
                            text: "An error occurred while deleting the data.",
                            icon: "error",
                        });
                    });
            } 
        });
    };
  if (loading) {
    return (
      <LoadingComponent />
    );
  }
  if (data.length === 0) {
    return <NoDataHandler title='No Products Fount' />;
  }

    return (
        <Fragment>
            <Breadcrumb title="Product List" parent="Product" />
            <div className="container-fluid">
                <div className="row">
                
                    <div className="col-sm-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{"#"}</th>
                                        <th scope="col">{"Product Code"}</th>
                                        <th scope="col">{"SKU"}</th>
                                        <th scope="col">{"Product"}</th>
                                        <th scope="col">{"Group"}</th>
                                        <th scope="col">{"Brand"}</th>
                                        <th scope="col">{"Material"}</th>
                                        <th scope="col">{"Category"}</th>
                                        <th scope="col">{"Action"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.map((item,index) => {
                                return(
                                    <tr key={index}>
                                        <th scope="row">{index+1}</th>
                                        <td>{item.productCode}</td>
                                        <td>{item.SKU}</td>
                                        <td>{item.productName}</td>
                                        <td>{item.group_name}</td>
                                        <td>{item.brand}</td>
                                        <td>{item.material}</td>
                                        <td>{item.category}</td>

                                        <td>
                                            <Link to={`${process.env.PUBLIC_URL}/pages/products/edit/${item.id}`} className="btn btn-xs btn-outline-success">Edit</Link>&nbsp;
                                            <button title="Delete" className="btn btn-xs btn-outline-danger" onClick={ (e) => DeleteData(item.id)}>
                                                Delete
                                            </button>
                                            
                                        </td>
                                    </tr>
                                );
                                })}
                                
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>
        </Fragment>
    );
};

export default AllProducts;